import React from 'react';

const Matches: React.FC = () => (
  <div style={{ padding: '24px', maxWidth: '600px', margin: '0 auto' }}>
    <h1 style={{ color: '#fff', marginBottom: '16px' }}>Matches</h1>
    <p style={{ color: '#9ca3af' }}>Your matches — wire to GET /matches when ready.</p>
  </div>
);

export default Matches;
